<script>
    export let puzzle;
</script>

<style>
    .Puzzle {
        display: grid;

        grid-template-columns: 40% 60%;

        column-gap: 5px;
        row-gap: 5px;
    }
    
    .installed {
        background-color: #4dee84;

        color: #211e27;
    }

    .installed p {
        height: 30px;
        line-height: 30px;

        margin-left: 10px;
        margin-top: 0;
        margin-bottom: 0;
    }

    .number {
		display: inline-block;
		
		width: 30px;
		height: 30px;
		line-height: 30px;
		
		text-align: center;
		
		font-size: 15px;
	
		background-color: #211e27;
		border: 3px solid #211e27;
		
		margin: 1px
	}
	
	.number.solved {
		border: 3px solid #d7f869;
    }

    .reward * {
        margin: 5px 0;
    }
    
    .reward .note {
        text-transform: none;
        font-size: 90%;
        font-weight: lighter;
    }
</style>

<div class="Puzzle" class:installed={puzzle.status == 'solved'}>
    {#if puzzle.status == 'pending' }
        <div class="solution">
            {#each puzzle.solution as number, i}
                <span class:solved={puzzle.progress > i} class="number">{number}</span>
            {/each}
        </div>
    {:else}
        <p>Installed</p>
    {/if}

    <div class="reward">
        <div class="title">{puzzle.reward.title}</div>
        <div class="note">{puzzle.reward.note}</div>
    </div>
</div>